export enum FeedbackActionsType {
  OPEN_PAGE = 'feedback/openPage',
}
